export default __webpack_public_path__ + "static/media/element_3.7c0eeb48.webp";